import { Product } from "./product.model";
import { Garment } from "./garment.model";

export class OrderPhase
{
    id: number;
    name: string;
    description: string;

    constructor()
    {           
    }

    getId?(): number
    {
        return this.id;
    }

    setId?(id: number)
    {
        this.id = id;
    }

    getName?(): string
    {
        return this.name;
    }

    setName?(name: string)
    {
        this.name = name;
    }

    getDescription?(): string
    {
        return this.description;
    }

    setDescription?(description: string)
    {
        this.description = description;
    }
}



// WEBPACK FOOTER //
// ./src/app/+core/common/model/order-phase.model.ts